<script>
    import { dbClearAllInvalidItems, clearAllInvalidItems, invalidateItem,user_data, parseCityStateZip } from './stores.js';
    import * as yup from 'yup'; 
    import Cleave from 'cleave.js';    
    import { onMount } from "svelte";
    import Progresscomponent from "./components/progresscomponent.svelte";
    import Chipscompnent from './components/chipscompnent.svelte';
    import Dtemplate from "./components/detailedtemplate.svelte";
    
    let cashout_element;
    let cashout_formatter;
    

    onMount(async() => {
        cashout_formatter = new Cleave(cashout_element, {
            numeral: true,
            prefix: '$',
            noImmediatePrefix: true
        });

    });

    const formSchema = yup.object().shape({
        cashout_element: yup
        .string()
        .required('Expected cashout amount is required to find the best rates.'),
    });
    async function checkNext() {
        clearAllInvalidItems();
        let res = false;
        await formSchema.validate({ 
            cashout_element: cashout_element.value.trim(),
        }).then(function (value) {
            res = true;
        }).catch(function (err) {
                invalidateItem(eval(err.path), err.errors[0]);
            res = false;
        });

        //check cashout validation
        if(res){
            let pp = parseInt($user_data.propertyvalue.toString().replace(/[^\d.-]/g, ''));
            let lb = parseInt($user_data.currentbalance.toString().replace(/[^\d.-]/g, ''));
            let ca = parseInt($user_data.cashoutamount.toString().replace(/[^\d.-]/g, ''));
            
            if(isNaN(pp)){
                pp = 0;
            }
            if(isNaN(lb)){
                lb = 0;
            }
            if(isNaN(ca)){
                ca = 0;
            }


            if(((ca + lb) / pp ) < 0.8){
                res = true;
            }else{
                invalidateItem(cashout_element, 'The cash-out amount + previous balance can’t be over 80% of the value of the home');
                res = false;
            }
        }
    

        return res;
    }

    function clearFunction() {
        dbClearAllInvalidItems();
    }

</script>

<Dtemplate
progress_mobile_version={true}
>
    <Progresscomponent 
    pre_next_callback_function={checkNext}
    title="How much cash do you want to take out?"
    >
    <div class="formcontainer">
        <input inputmode="numeric" on:keyup={()=>{ clearFunction(); }} bind:this={cashout_element} bind:value={$user_data.cashoutamount} type="text" placeholder="Cash out amount" />
    </div>
    </Progresscomponent>
</Dtemplate>

<style>
.formcontainer {
    margin-top: 40px;
    width: 60%;
    max-width: 350px;
    margin-left: auto;
    margin-right: auto;
}
.formcontainer input {
    width: 100%;
    padding: 10px;
}
@media (max-device-width: 1024px), (max-width: 1023px) {
    .formcontainer {
        width: 100%;
        max-width: 280px;
    }

}

</style>